import * as React from 'react';;
import { Transaction } from '../../types/bank';

type Props = {
  transactions: Transaction[];
  getTransactionIcon: (type: Transaction['type']) => React.ReactNode;
  getTransactionColor: (type: Transaction['type']) => string;
};

export default function RecentActivity({ transactions, getTransactionIcon, getTransactionColor }: Props) {
  const sortedTransactions = React.useMemo(
    () => transactions.slice().sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()),
    [transactions]
  );

  return (
    <div className="bg-white/60 backdrop-blur-md rounded-xl shadow-sm border border-gray-200/50 p-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Recent Activity</h3>
      <div className="space-y-4">
        {sortedTransactions.slice(0, 5).map(transaction => (
          <div
            key={transaction.id}
            className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0"
          >
            <div className="flex items-center gap-3">
              <div className={`p-2 rounded-lg ${getTransactionColor(transaction.type)}`}>
                {getTransactionIcon(transaction.type)}
              </div>
              <div>
                <p className="font-medium text-gray-800">{transaction.description}</p>
                <p className="text-sm text-gray-500">{transaction.category}</p>
              </div>
            </div>
            <div className="text-right">
              <p className={`font-medium ${
                transaction.amount > 0 ? 'text-green-600' : 'text-red-600'
              }`}>
                {transaction.amount > 0 ? '+' : ''}{transaction.amount} pts
              </p>
              <p className="text-sm text-gray-500">
                {new Date(transaction.date).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric'
                })}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}